import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
// import p1 from 'assests/Photos/Clubs/LitreryClub/2023/KannadaCCA/1.jpg';
// import p2 from 'assests/Photos/Clubs/LitreryClub/2023/KannadaCCA/2.jpg';
// import p3 from 'assests/Photos/Clubs/LitreryClub/2023/KannadaCCA/3.jpg';
// import p4 from 'assests/Photos/Clubs/LitreryClub/2023/KannadaCCA/4.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/Literaryclub2023/components';
import { LiterarySidebar } from 'views/Literaryclub2023/components';

const KannadaCCA2023 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });

    const [config, setConfig] = useState({ base_image_archive_url: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/KannadaCCA/1.webp`;
    const p2 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/KannadaCCA/2.webp`;
    const p3 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/KannadaCCA/3.webp`;
    const p4 = `${config.base_image_archive_url}/academic-year-2023-24/home/events-activities/association/LitreryClub/KannadaCCA/4.webp`;

    const photos = [
               {
                    src: p3,
                    source: p3,
                    rows: 1.3,
                    cols: 2,
                },  
          {
                    src: p1,
                    source: p1,
                    rows: 2,
                    cols: 1,
          },
          {
                    src: p2,
                    source: p2,
                    rows: 1,
                    cols: 1,
          },
          {
                    src: p4,
                    source: p4,
                    rows: 1,
                    cols: 1,
                },
     
    ];

    return (
        <Main>

            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box paddingX={{ xs: 0, sm: 4, md: 6 }}>
                            <Typography variant='h5' align='center' >
                                KANNADA CCA
                                </Typography>
                                <br />
                            <Typography variant='h7' align='justify' >
                                Class 3: Pick and Speak  
                                <br />
                                Class 4: Monoacting (Freedom Fighters)
                                <br />
                                Class 5:  Vachana Recitation 
                                </Typography>
                              
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: 3 to 5  Date: 3,4 & 5 January 2024
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                              ><br />
                                "Poetry comes alive to me through recitation!"
                                <br />
                            </Typography> */}
                            <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                The final round of Kannada CCA, which was held in the first week of January 2024 saw active and enthusiastic participation from the students of Classes 3, 4 and 5. 
                                Students of Class 3 spoke voraciously about the topics that they got in the Pick and Speak activity.
                                <br />
                                Students of Class 4 presented their Monoacting on ‘Freedom Fighters’.They were confident and well-prepared for the event. They also made it interesting with their colourful hand puppets and costumes.
                                <br />
                                Students of Class 5 presented Vachanagalu. They were not just successful in echoing the thoughts and mirroring the feelings, but also in emulating the persona in the roles that they chose through their dramatic appropriateness and articulation. 

                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                              ><br />
                                "Interviewing is a skill that takes many years to perfect and most of us are still mastering the art"
                                <br />
                            </Typography> */}
                            </Box>
                            
                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 300 : 500}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={4}>

                        <Box marginBottom={4}>
                                    <Sidebar2023/>
                        </Box>
                        <Box marginBottom={4}>
                            <LiterarySidebar/>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Main>


    );
};

export default KannadaCCA2023;